export default __webpack_public_path__ + "landingPagePS_LogedIn.html";